import React from 'react';
import { View } from 'react-native';
import { useCan } from '../../auth/hooks/useCan';
import { TPermissionRequirement } from '../../auth/types';

export const Can: React.FC<{ req: TPermissionRequirement; children: React.ReactNode; fallback?: React.ReactNode; }> = ({ req, children, fallback = null }) => {
    const { allowed } = useCan(req);
    return <>{allowed ? children : fallback}</>;
};

export const Require: React.FC<{ req: TPermissionRequirement; children: React.ReactNode; }> = ({ req, children }) => {
    const { allowed } = useCan(req);
    if (!allowed) return <View />;
    return <>{children}</>;
};
